<template>
  <el-dialog
    title="新增返优惠客户" :visible.sync="visible" @close="handleClose"
    width="500px">
    <el-form
      class="form"
      :model="form"
      :rules="rules"
      ref="form"
      :label-width="formLabelWidth">
      <el-form-item label="客户名称" prop="customList">
        <search-select
          v-model="form.customList"
          placeholder="请输入关键词"
          type="orgIdsCustomer"
          :key="form.customList ? form.customList.id : Date.now()"
          :extra-params="{ orgIds: ['1094530434974004277','1194877555086222222','1194877555086111111','1194877513180513457','1194877513180513458'] }"
          :inital-option="form.custom"
          ref="cusSelect"></search-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import SearchSelect from '../../../components/searchSelect'
import AjaxSelect from '../../../components/ajaxSelect/index'

export default {
  name: 'addOrEditDialog',
  components: { SearchSelect, AjaxSelect },
  props: {
  },
  data () {
    return {
      visible: true,
      formLabelWidth: '120px',
      form: {
        org: {},
        customList: {}
      },
      rules: {
        customList: [
          { required: true, message: '请选择客户' }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(['rebateAccountSave']),
    handleSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { customList = {} } = this.form
          if (!customList.name) {
            this.$message.warning('请选择客户')
            return
          }
          const params = {
            customerName: customList.name
          }
          this.rebateAccountSave(params).then((res) => {
            if (res.success) {
              this.$message.success('新增成功')
              this.$emit('closeAdd', 1)
            }
          })
        } else {
          return false
        }
      })
    },
    handleOrgChange (e) {
      console.log('[ e ] >', e)
    },
    handleClose () {
      this.$emit('closeAdd', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin: 0 auto;
}

.form-input, .form-select, .el-input-number {
  width: 200px;
}
.container-tag {
  margin-top: 5px;

  .el-tag {
    margin-right: 10px;
  }
}
.el-input-search{
  width: 180px;
}
</style>
